
import React from 'react';
import { CheckCircle2, HeadphonesIcon, AlertCircle, HelpCircle } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import GuideCard from './GuideCard';
import TranslatedText from '@/TranslatedText';

const GuidesSection = () => {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <GuideCard 
          title={<TranslatedText text="Getting Started Guide" />}
          description={<TranslatedText text="Learn how to set up your account and make your first purchase." />}
          icon={<CheckCircle2 className="h-8 w-8 text-green-500" />}
        />
        <GuideCard 
          title={<TranslatedText text="Order Management" />}
          description={<TranslatedText text="How to track, modify or cancel your orders." />}
          icon={<HeadphonesIcon className="h-8 w-8 text-blue-500" />}
        />
        <GuideCard 
          title={<TranslatedText text="Returns & Refunds" />}
          description={<TranslatedText text="Step-by-step guide to returning products and getting refunds." />}
          icon={<AlertCircle className="h-8 w-8 text-red-500" />}
        />
        <GuideCard 
          title={<TranslatedText text="Account Settings" />}
          description={<TranslatedText text="How to update your profile, addresses, and payment methods." />}
          icon={<HelpCircle className="h-8 w-8 text-purple-500" />}
        />
      </div>
      
      <Alert className="mt-8">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle><TranslatedText text="Tip" /></AlertTitle>
        <AlertDescription>
          <TranslatedText text="Can't find what you're looking for? Try using the search bar at the top of the page or contact our support team directly." />
        </AlertDescription>
      </Alert>
    </>
  );
};

export default GuidesSection;
